import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.initializeStyledSelect()
  }

  disconnect() {
    this.cleanupStyledSelect()
  }

  initializeStyledSelect() {
    const $select = $(this.element)

    if (!$select.data('custom-select')) {
      $select.customSelect()
    }
  }

  cleanupStyledSelect() {
    const $select = $(this.element)
    const customSelectData = $select.data('custom-select')

    if (customSelectData) {
      $select.next('.custom-select').remove()
      $select.show()
      $select.removeData('custom-select')
    }
  }
}
